import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { LANGUAGES } from "../i18n/translations";
import logo from "../assets/raiz-logo.svg";
import TopRibbon from "./TopRibbon";
import { SHOP_URL } from "../constants";
import "./Navbar.css";

function Navbar() {
  const { language, changeLanguage, t } = useLanguage();

  return (
    <header className="Navbar">
      <TopRibbon/>
      <div className="Navbar-inner">
        <Link to="/" className="Navbar-badge" aria-label="Raiz home">
          <img src={logo} alt="Raiz" className="Navbar-logo" />
        </Link>

        <nav className="Navbar-links">
          <a href={SHOP_URL}>{t("nav.shop")}</a>
          <Link to="/catering">{t("nav.catering")}</Link>
          <label className="Navbar-lang" aria-label="Choose language">
            <select
              value={language}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              {LANGUAGES.map(({ code, label }) => (
                <option key={code} value={code}>
                  {label}
                </option>
              ))}
            </select>
          </label>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
